import { createSelector, createStructuredSelector } from 'reselect';
import _ from 'lodash';

import * as Tables from 'state/tables';
import { StoreType } from '@tock/shared/utils/connect';

export const tablesStateSelector = createStructuredSelector<StoreType, { tables: Tables.State }>({
  tables: (state: StoreType): Tables.State => state.tables,
});

export const tablesSelector = createSelector(
  tablesStateSelector,
  (state): Tables.Table[] => state.tables.data || []
);

export const tableIdToTableSelector = createSelector(
  tablesSelector,
  (tables: Tables.Table[]): Dictionary<Tables.Table> => {
    return _.keyBy(tables, 'id');
  }
);
